import { render, staticRenderFns } from "./haibao.vue?vue&type=template&id=8d17a534&scoped=true&"
import script from "./haibao.vue?vue&type=script&lang=js&"
export * from "./haibao.vue?vue&type=script&lang=js&"
import style0 from "./haibao.vue?vue&type=style&index=0&id=8d17a534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d17a534",
  null
  
)

export default component.exports